import { Link, useNavigate, useParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { ArrowLeft } from "@/components/icons";
import { OrgDetailPanel } from "@/pages/OrganizationsPage";
import { useT } from "@/app/localization";

/**
 * Full details page for a single organization.
 *
 * Mirrors the units pattern: the Organizations list shows a brief slide-over
 * panel on the right, and from there you can open this full page. The body is
 * the shared OrgDetailPanel rendered in "page" mode (which also surfaces the
 * Reports area).
 */
export function OrganizationDetailPage() {
  const t = useT();
  const { orgId } = useParams();
  const navigate = useNavigate();
  const id = Number(orgId);

  if (!orgId || Number.isNaN(id)) {
    return (
      <div className="p-5">
        <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive">
          {t("operator.orgs.invalid_id")}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5 pt-[86px]">
      <div>
        <Button variant="ghost" size="sm" className="gap-1 mb-2" asChild>
          <Link to="/organizations">
            <ArrowLeft className="h-4 w-4" /> {t("operator.unit.back_to", { page: t("operator.nav.organizations") })}
          </Link>
        </Button>
      </div>

      <OrgDetailPanel
        orgId={id}
        mode="page"
        onDeleted={() => navigate("/organizations")}
      />
    </div>
  );
}
